import { ApiPersonDetailReviewsListServiceTypeCategory as ServiceTypeCategories } from '@rover/rsdk/src/apiClient/latest/model/apiPersonDetailReviewsListServiceTypeCategory';
import type { TrainerInsights } from '@rover/rsdk/src/apiClient/latest/model/trainerInsights';

export type ServiceReviewFlags = {
  hasTrainingReviews: boolean;
  hasOtherServicesReviews: boolean;
  /** The training/all-services filter is only meaningful when both kinds of reviews exist */
  shouldShowFilter: boolean;
  defaultCategory: ServiceTypeCategories;
};

export function getServiceReviewFlags(trainerInsights: TrainerInsights): ServiceReviewFlags {
  const hasTrainingReviews = trainerInsights.servicesWithTextReviews.some(
    (service) => service.slug === 'dog-training'
  );
  const hasOtherServicesReviews = trainerInsights.servicesWithTextReviews.some(
    (service) => service.slug !== 'dog-training'
  );

  return {
    hasTrainingReviews,
    hasOtherServicesReviews,
    shouldShowFilter: hasTrainingReviews && hasOtherServicesReviews,
    defaultCategory: hasTrainingReviews
      ? ServiceTypeCategories['dog-training']
      : ServiceTypeCategories['all-services'],
  };
}
